/* @generated */
/* empty css                                         *//* empty css                                  */var shadeBg = "var(--dig-unkc3t0_4-3-1)";
var shadeBgActive = "var(--dig-unkc3t1_4-3-1)";
var shadeDuration = "var(--dig-unkc3t2_4-3-1)";
var hoverBefore = "dig-unkc3t3_4-3-1";
var focusBefore = "dig-unkc3t4_4-3-1";
var activeBefore = "dig-unkc3t5_4-3-1";
var controlledHover = "dig-unkc3t6_4-3-1";
var controlledFocus = "dig-unkc3t7_4-3-1";
var controlledActive = "dig-unkc3t8_4-3-1";
var ancestor = "dig-unkc3t9_4-3-1";
var animated = "dig-unkc3ta_4-3-1";
var shadeClass = "dig-unkc3tc_4-3-1 dig-unkc3tb_4-3-1 dig-ekabinr_4-3-1 dig-ekabinf_4-3-1";
var shadeTransition = { up: "dig-unkc3td_4-3-1", down: "dig-unkc3te_4-3-1", right: "dig-unkc3tf_4-3-1", left: "dig-unkc3tg_4-3-1" };
export {
  activeBefore,
  ancestor,
  animated,
  controlledActive,
  controlledFocus,
  controlledHover,
  focusBefore,
  hoverBefore,
  shadeBg,
  shadeBgActive,
  shadeClass,
  shadeDuration,
  shadeTransition
};
